// scanExportStore.js — state of the Scan export, at module level (see scanExport.js for why). No
// network code here, so any component can import it cheaply (RenderBar, the dock, HOVTab).
import { useSyncExternalStore } from 'react';
const IDLE = { running: false, done: 0, total: 0, msg: '', failed: [], unseen: false };
let state = IDLE;
let landed = [];          // files written this run: { id, exportedAt, exportedName }
let outcome = null;       // { failedIds: Set } — taken once by a mounted HOVTab
let claimed = false;
const listeners = new Set();

export function setState(patch) {
  state = typeof patch === 'function' ? patch(state) : Object.assign({}, state, patch);
  listeners.forEach(l => l());
}
export function subscribe(l) { listeners.add(l); return () => listeners.delete(l); }
export function getScanExport() { return state; }
export function useScanExport() { return useSyncExternalStore(subscribe, getScanExport, getScanExport); }
export function getLanded() { return landed; }
export function resetRun() { landed = []; outcome = null; claimed = false; }
export function addLanded(entry) { landed = landed.concat([entry]); }
export function setOutcome(o) { outcome = o; }

// A component that already shows the export (Scan itself, a RenderBar) registers, so the global
// dock only appears where nothing else does. Kept OUT of the run state on purpose: registering must
// not re-render the registering bar (that would replay / cut the exported stack's fly-in animation).
let presenters = 0;
const pListeners = new Set();
const pNotify = () => pListeners.forEach(l => l());
export function registerPresenter() {
  presenters += 1; pNotify();
  return () => { presenters = Math.max(0, presenters - 1); pNotify(); };
}
export function usePresenters() {
  return useSyncExternalStore(l => { pListeners.add(l); return () => pListeners.delete(l); }, () => presenters, () => presenters);
}

// One export at a time. claim() is taken at click time (before the folder picker / numbering
// await), so a double click or a re-entry cannot start a second loop.
export function claimScanExport() { if (state.running || claimed) return false; claimed = true; return true; }
export function releaseScanExport() { claimed = false; }

export function takeOutcome() { const o = outcome; outcome = null; if (o) setState({ unseen: false }); return o; }
export function dismissUnseen() { setState({ unseen: false }); }
export function clearSummary() { if (!state.running && (state.msg || state.failed.length)) setState({ msg: '', failed: [] }); }
export function patchFailed(id, patch) {
  setState(s => Object.assign({}, s, { failed: (s.failed || []).map(x => x.id === id ? Object.assign({}, x, patch) : x) }));
}

